module.exports = __webpack_public_path__ + "media/comeback.8296c44c.mp3";